
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesPromoDialog extends Serenity.EntityDialog<ECommSalesPromoRow, any> {
        protected getFormKey() { return ECommSalesPromoForm.formKey; }
        protected getIdProperty() { return ECommSalesPromoRow.idProperty; }
        protected getLocalTextPrefix() { return ECommSalesPromoRow.localTextPrefix; }
        protected getService() { return ECommSalesPromoService.baseUrl; }
        protected getDeletePermission() { return ECommSalesPromoRow.deletePermission; }
        protected getInsertPermission() { return ECommSalesPromoRow.insertPermission; }
        protected getUpdatePermission() { return ECommSalesPromoRow.updatePermission; }

        protected form = new ECommSalesPromoForm(this.idPrefix);

    }
}